import React, {useState} from "react";
import MediaTable from "./MediaTable/MediaTable";
import ListsTable from "./ListsTable/ListsTable";
import Collapse from "@material-ui/core/Collapse";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import {getCardIcon} from "../../../utils/utils"

function ClipLaunderingCard(props) {

    const [expanded, setExpanded] = useState(false);
    const [firstTime, setFirstTime] = useState(true);

    const { clip_laundering_data } = props
    let initialExpand = clip_laundering_data.flag === "positive" ? false : true
    
    if (initialExpand !== expanded && firstTime === true) {
        setExpanded(initialExpand);
    }
    const handleExpand = (event) => {
        event.stopPropagation();
        setFirstTime(false)
        setExpanded(!expanded);
    };

    return (
        <div className="analysisCard">
            <div style={{display:"flex"}}>
                <div 
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px"}}
                >
                    Clip Laundering
                </div>
                <div style={{margin:"auto 10px"}}>
                    {getCardIcon(clip_laundering_data.flag)}
                </div>
                {clip_laundering_data.data.length === 0 ? null :
                <IconButton style={{marginLeft: "auto"}} onClick={handleExpand}>
                    {expanded ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                </IconButton>             
                }                    
            </div>
            {clip_laundering_data.data.length === 0 ? null :
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <div 
                    className={["blueText", "bold"].join(" ")}
                    style={{margin:"auto 0px", fontSize: "16px", marginTop: "8px"}}
                >
                    Mídias
                </div>
                <div 
                    className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}
                >
                    <MediaTable news={clip_laundering_data.data.news_list}/>
                </div>
                <div 
                    className={["blueText", "subtitleSize", "bold"].join(" ")}
                    style={{margin:"auto 0px", fontSize: "16px", marginTop: "32px"}}
                >
                    Listas
                </div>
                <div className={["normalText", "normalMediumSize", "internalCardContainer"].join(" ")}>
                    <ListsTable lists={clip_laundering_data.data.list}/>
                </div>

                <div className="normalText normalMediumSize" style={{marginTop: "32px"}}>
                    <span style={{fontWeight: "bold", color: "#0b1f82", marginRight: "8px", fontSize: "16px"}}>Crimes:</span>
                    {(clip_laundering_data.data.crimes || "").trim().replace(/^,+|,+$/g, '').replaceAll(',', ', ')}
                </div>
            </Collapse> 
            }     
        </div>
        );
}

export default ClipLaunderingCard